import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';

const TruncateText = ( { characterLimit = 200, text } ) => {
	const [ showMore, setShowMore ] = useState( false );

	if ( ! text ) {
		return null;
	}

	const shouldTruncate = text.length > characterLimit;
	const displayText = showMore ? text : text.slice( 0, characterLimit );

	return (
		<span className="block space-x-1">
			<span>
				{ displayText }
				{ ! showMore && shouldTruncate && '...' }
			</span>
			{ shouldTruncate && (
				<button
					type="button"
					onClick={ () => setShowMore( ( prev ) => ! prev ) }
					className="text-text-secondary [background:none] appearance-none border-0 p-0 m-0 cursor-pointer"
				>
					{ showMore
						? __( 'Show less', 'suremails' )
						: __( 'Show more', 'suremails' ) }
				</button>
			) }
		</span>
	);
};

export default TruncateText;
